import React, { useMemo } from 'react'
import { TrialPreEndModalCard } from 'Features/accountSettings/components/Billing/TrialPreEndModal/TrialPreEndModal.styled'
import { useTranslation } from 'react-i18next'
import { ThreatGroupsStyled } from 'Features/accountSettings/components/Billing/TrialPreEndModal/Components/ThreatGroupsPm/ThreatGroupsPm.styled'
import { Options, SeriesOptionsType } from 'highcharts'
import { useGetBotMitigationData } from 'Features/home/api/getProductData'
import { reduceBotzappingData } from 'Features/home/routes/Home/utils'
import { DrillDownPie } from '@clickcease/cc-client-components-lib'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { toUnixDateRangeFix } from 'Utils/dates'

type ThreatGroupDataItem = {
  name: string
  y: number
}

export const ThreatGroupsBm = () => {
  const { t } = useTranslation('accountSettings')
  const { timezoneCountry } = useUserStore()
  const { data: plansDetails } = useGetPlansDetails()
  const serverDateConversion = toUnixDateRangeFix(timezoneCountry, {
    from: new Date(plansDetails?.currentPeriodStart || ''),
    to: new Date(),
  })
  const { data: botMitigationData } = useGetBotMitigationData({
    startDate: serverDateConversion?.from,
    endDate: serverDateConversion?.to,
  })

  const calculatedReducedBotzappingData = useMemo(() => {
    return reduceBotzappingData({
      datedSummary: botMitigationData?.datedSummaries,
      insights: botMitigationData?.insights,
    })
  }, [botMitigationData])

  const bmData = useMemo(() => {
    const data: Array<ThreatGroupDataItem> = []
    calculatedReducedBotzappingData.threatGroupsBreakdown.data.forEach((item) => {
      data.push({
        name: item.name.replace('Invalid ', ''),
        y: item.y,
      })
    })
    return data
  }, [calculatedReducedBotzappingData])

  const chartOptions: Options = {
    chart: {
      type: 'pie',
      height: 125,
      width: 320,
    },
    series: [
      {
        name: t('trial_pre_end_modal.threats_groups_types'),
        colorByPoint: true,
        type: 'pie',
        size: '80',
        marginTop: 0,
        marginBottom: 0,
        innerSize: '65%',
        data: bmData,
      } as SeriesOptionsType,
    ],
    legend: {
      useHTML: false,
      verticalAlign: 'middle',
      itemMarginBottom: 6,
      align: 'right',
      itemStyle: { fontSize: '13px', fontWeight: '300' },
    },
    tooltip: {
      enabled: true,
      outside: false,
      useHTML: true,
      style: {
        zIndex: 100,
      },
    },
  }
  return (
    <TrialPreEndModalCard>
      <ThreatGroupsStyled>{t('trial_pre_end_modal.threats_groups_types')}</ThreatGroupsStyled>
      {bmData && (
        <DrillDownPie
          labelOptions={{ hideNumber: true }}
          options={chartOptions}
          chartCSS={{ maxWidth: '301px', height: '100%' }}
          data={bmData}
        />
      )}
    </TrialPreEndModalCard>
  )
}
